module.exports = "<p><img src=\"" + require("../assets/price.png") + "\" alt=\"产品价格表\"></p>\n";